import React from 'react';
import { useParams } from 'react-router-dom';
import ProjectPlansContainer from '../../containers/manufacturingmng/ProjectPlansContainer';

/**
 * 프로젝트별 생산 계획 목록 페이지
 * - /manufacturingmng/:projectId/plans
 * - 특정 프로젝트의 생산 계획 목록 표시
 */
const ProjectPlansPage = () => {
  const { projectId } = useParams();
  const pageUrl = '/manufacturingmng';
  
  return <ProjectPlansContainer projectId={projectId} pageUrl={pageUrl} />;
};

export default ProjectPlansPage;
